import React from "react";
import { getValue } from "@utils/lodash";

function ResetSvgComponent(props: any) {
  return (
      <svg xmlns="http://www.w3.org/2000/svg"
        height={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        width={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
      viewBox="0 0 24 24">
      <defs>
        <clipPath id="clip-path-reset">
          <rect id="Rectangle_18379" data-name="Rectangle 18379" width="24" height="24" transform="translate(-11507 -4683)" fill="#fff"/>
        </clipPath>
      </defs>
      <g id="Mask_Group_410" data-name="Mask Group 410" transform="translate(11507 4683)" clip-path="url(#clip-path-reset)">
        <path id="restart_alt_FILL0_wght300_GRAD0_opsz24" d="M13.157-10.5A7.7,7.7,0,0,1,8.19-13.133a7.729,7.729,0,0,1-1.966-5.259,7.734,7.734,0,0,1,.642-3.1,8.06,8.06,0,0,1,1.8-2.607L9.8-22.966a5.865,5.865,0,0,0-1.482,2.072,6.352,6.352,0,0,0-.5,2.5,6.21,6.21,0,0,0,1.5,4.118,6.219,6.219,0,0,0,3.835,2.18Zm2.133.02v-1.593A6.616,6.616,0,0,0,19.112-14.3a6.1,6.1,0,0,0,1.512-4.09,6.131,6.131,0,0,0-1.867-4.514,6.186,6.186,0,0,0-4.533-1.859h-.377l1.44,1.434-1.124,1.119L10.8-25.56l3.364-3.349,1.124,1.119-1.44,1.434h.377A7.737,7.737,0,0,1,19.9-24.041a7.669,7.669,0,0,1,2.326,5.649,7.659,7.659,0,0,1-1.971,5.232A7.981,7.981,0,0,1,15.29-10.48Z" transform="translate(-11509.224 -4651.306)" 
        fill={
          getValue(props, `color`, "") ? getValue(props, `color`, "") : "#000000"
        } />
      </g>
    </svg>
  );
}

export default ResetSvgComponent;
